<template>
  <v-layout justify-center>
    <v-flex xs48 sm48>
      <v-toolbar color="grey" dark>
        <v-toolbar-title>List of Vendors</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon>search</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container
          fluid
          grid-list-md
        >
          <v-layout row wrap>
            <v-flex
              :key="amazon"
              v-bind="{ [`xs12`]: true }"
            >
              <v-card height="125px" width="125px">
<a target="_blank" href="https://www.amazon.ca?&_encoding=UTF8&tag=qubercanada1-20&linkCode=ur2&linkId=6f4b710e7ea4b511bcc7e5d868dd935f&camp=15121&creative=330641">Amazon Home Link</a><img src="//ir-ca.amazon-adsystem.com/e/ir?t=qubercanada1-20&l=ur2&o=15" width="1" height="1" border="0" alt="" style="border:none !important; margin:0px !important;" />

                <!-- <iframe src="//rcm-na.amazon-adsystem.com/e/cm?o=15&p=21&l=ur1&category=amazonhomepage&f=ifr&linkID=4ba10bce3cc08edbae3f5982dfdf4547&t=qubercanada1-20&tracking_id=qubercanada1-20" width="125" height="125" scrolling="no" border="0" marginwidth="0" style="border:none;" frameborder="0"></iframe> -->
<!-- <iframe src="//rcm-na.amazon-adsystem.com/e/cm?o=15&p=12&l=ur1&category=best_seller&banner=1DJWQCNP30APRAVQX1G2&f=ifr&linkID=6d64edf229b4af0f50f04ee714b72e25&t=qubercanada1-20&tracking_id=qubercanada1-20" width="300" height="250" scrolling="no" border="0" marginwidth="0" style="border:none;" frameborder="0"></iframe>
                 <iframe src="//rcm-na.amazon-adsystem.com/e/cm?o=15&p=12&l=ur1&category=best_seller&banner=1J8VAAXQRG4CYTA5MK82&f=ifr&linkID=2a36d031abaffd0515bd690f492501b5&t=qubercanada1-20&tracking_id=qubercanada1-20" width="150" height="125" scrolling="no" border="0" marginwidth="0" style="border:none;" frameborder="0"></iframe>  -->

              </v-card>
            </v-flex>
            <v-flex
              :key="tickets"
              v-bind="{ [`xs12`]: true }"
            >
              <v-card height="125px" width="125px">
              <a href="http://www.kqzyfj.com/click-9006496-11215359">
                <img src="http://www.ftjcfx.com/image-9006496-11215359" width="125" height="125" alt="Tickets at TicketNetwork.com" border="0"/></a>
              </v-card>
            </v-flex>

            <!--
"TicketNetwork",,"11215359","TN General - Sports, Concerts and Theater - 125 x 125","Buy Sports, Concerts or Theater Tickets","Sports, Concerts, Theater, Tickets","Banner","N/A","N/A","16-Aug-2018",
"<a href=""http://www.kqzyfj.com/click-9006496-11215359"" target=""_top"">
<img src=""http://www.ftjcfx.com/image-9006496-11215359"" width=""125"" height=""125"" alt=""Find Sports, Concerts or Theater Tickets"" border=""0""/></a>","<script type=""text/javascript"" language=""javascript"" src=""http://www.kqzyfj.com/placeholder-37453909?target=_top&mouseover=N""></script>","http://www.jdoqocy.com/click-9006496-11215359","N/A","","","","Events","2288710","Active","English","No"
              -->

            <v-flex
              :key="spa"
              v-bind="{ [`xs12`]: true }"
            >
              <v-card height="125px" width="125px">

<a href="http://www.dpbolvw.net/click-9006496-12496743" target="_top">
<img src="http://www.ftjcfx.com/image-9006496-12496743" width="125" height="125" alt="" border="0"/></a>
              </v-card>
            </v-flex>
           <v-flex
              :key="turbo"
              v-bind="{ [`xs12`]: true }"
            >
              <v-card height="125px" width="125px">

<a href="http://www.jdoqocy.com/click-9006496-13607901" target="_top">
<img src="http://www.awltovhc.com/image-9006496-13607901" width="125" height="125" alt="turbotax" border="0"/></a>
              </v-card>
            </v-flex>
           <v-flex
              :key="toms"
              v-bind="{ [`xs12`]: true }"
            >
              <v-card height="125px" width="125px">
            <a href="https://click.linksynergy.com/fs-bin/click?id=8I4Yk*p35wQ&offerid=296545.32&subid=0&type=4"><IMG border="0"   alt="TOMS (Canada)" src="https://ad.linksynergy.com/fs-bin/show?id=8I4Yk*p35wQ&bids=296545.32&subid=0&type=4&gridnum=4"/></a>
              </v-card>
            </v-flex>
           <v-flex
              :key="lego"
              v-bind="{ [`xs12`]: true }"
            >
              <v-card height="125px" width="125px">
            <a href="http://click.linksynergy.com/fs-bin/click?id=8I4Yk*p35wQ&offerid=208931.10000050&type=4&subid=0">
            <IMG border=0 alt="Banner" width="125" height="125" src="https://www.logolynx.com/images/logolynx/89/890656bada8f2ab9815e55f374b7ad23.png"/></a>
            <!-- <IMG border=0 alt=button width="125" height="125" src="http://ad.linksynergy.com/fs-bin/show?id=8I4Yk*p35wQ&bids=208931.10000050&type=4&subid=0"/> -->
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: () => ({
    cards: [
      { title: 'Pre-fab homes', src: '//rcm-na.amazon-adsystem.com/e/cm?o=15&p=12&l=ur1&category=best_seller&banner=1J8VAAXQRG4CYTA5MK82&f=ifr&linkID=2a36d031abaffd0515bd690f492501b5&t=qubercanada1-20&tracking_id=qubercanada1-20', flex: 6 },
      { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }
    ]
  })
}
</script>
